// export DsfPlatformCardBox from "./cardBox";

// export DsfPlatformCardItemByCourse from "./cardItemByCourse";

// export DsfPlatformCardItemByCollection from "./cardItemByCollection";

// export DsfPlatformCardItemByTeacher from "./cardItemByTeacher";

// export DsfPlatformCardItemByTeacherList from "./cardItemByTeacherList";

// export DsfPlatformCardItemByTrain from "./cardItemByTrain";


export const DsfPlatformCardBox=dsf.defineLazyComponent('DsfPlatformCardBox',()=>require('./cardBox.vue'))
